module.exports = __webpack_public_path__ + "assets/dc7aeedfba865155ca14370067ae2bd8.png";